// @flow
// ### AUTOMATICALLY GENERATED FILE. Remove this comment to preserve your edits in the file. ###
import _pickBy from 'lodash/pickBy';
import gql from 'graphql-tag';
import { apolloQuery, apolloSubmitForm } from '../../core/data/apolloClient';
import { franchiseeMetaModel } from './Franchisee.model';

export function filterFranchiseeInput(values) {
  return _pickBy(values, (_, key) => key in franchiseeMetaModel.rules || key === 'id');
}

export function listFranchisees(filter?: ?{ [string]: string }, shape) {
  return apolloQuery(
    gql`
      query ($filter: FranchiseesFilter) {
        listFranchisees(filter: $filter) ${shape}
      }
    `,
    { filter }
  );
}

export function getFranchisee(id: string, shape) {
  return apolloQuery(
    gql`
      query ($id: String!) {
        getFranchisee(id: $id) ${shape}
      }
    `,
    { id }
  );
}

export function createFranchisee(inputValues, outputShape) {
  return apolloSubmitForm(
    gql`
      mutation ($input: FranchiseeCreate!) {
        createFranchisee(input: $input) ${outputShape}
      }
    `,
    { input: inputValues }
  );
}

export function updateFranchisee(inputValues, outputShape) {
  return apolloSubmitForm(
    gql`
      mutation ($input: FranchiseeUpdate!) {
        updateFranchisee(input: $input) ${outputShape}
      }
    `,
    { input: inputValues }
  );
}
